import { bindable } from 'aurelia-typed-observable-plugin';
import { bindingMode } from 'aurelia-framework';
import { GaugeBase } from 'app/shared/elements/gauges/gauge-base';

const DIMENSIONS = Object.freeze({
    stroke: 2,
    height: 200,
    width: 400,
    outerRX: 198,
    outerRY: 196,
    innerRX: 101,
    innerRY: 100
});

@bindable.number({ name: 'value' })
@bindable.string({ name: 'label' })
@bindable.stringNull({ name: 'color' })
@bindable.number({ name: 'min' })
@bindable.number({ name: 'max' })
@bindable.number({ name: 'precision' })
export class EssHalfDonutGaugeCustomElement extends GaugeBase {

    protected outerX = 0;
    protected outerY = 0;
    protected innerX = 0;
    protected innerY = 0;

    valueChanged() {
        const percent = this.normalize(this.value);
        const deg = !isNaN(percent) ? (1.0 - percent) * Math.PI : 0;
        this.outerX = Math.cos(deg) * DIMENSIONS.outerRX + DIMENSIONS.width / 2;
        this.outerY = DIMENSIONS.height - Math.sin(deg) * DIMENSIONS.outerRY - DIMENSIONS.stroke;
        this.innerX = Math.cos(deg) * DIMENSIONS.innerRX + DIMENSIONS.width / 2;
        this.innerY = DIMENSIONS.height - Math.sin(deg) * DIMENSIONS.innerRY - DIMENSIONS.stroke;
    }
}
